<template>
  <div class="animated fadeIn">
   <b-modal ref="modal-product" scrollable centered button-size="sm" v-on:hide="aborted" v-on:close="aborted">
     <template #modal-title>
       <i class="fas fa-briefcase"></i> ADICIONAR PRODUTO
     </template>
     <div class="pb-4">
      <div class="form-group row pt-2">
         <div class="col-md-12">
           <label for="txtGroup"><small class="text-danger" v-if="form.produtoId.required">*</small> Produto:</label>
           <div class="input-group">
             <span class="input-group-addon"><i class="fas fa-briefcase"></i></span>
             <b-form-select v-model="form.produtoId.value" :options="form.produtoId.options">
               <template slot="first">
                 <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
               </template>
             </b-form-select>
           </div>
         </div>
      </div>
      <div class="form-group row pt-2" v-if="checkTypeBoard(card)">
         <div class="col-md-12">
           <label for="txtGroup"><small class="text-danger" v-if="form.operacao.required">*</small> Operação:</label>
           <div class="input-group">
             <span class="input-group-addon"><i class="fas fa-sticky-note"></i></span>
             <b-form-input type="text"
              placeholder="Operação"
              v-model="form.operacao.value"
              :maxlength="form.operacao.maxlength"
              :required="form.operacao.required"
              :state="form.operacao.state"
              :disabled="isEditing ? true : false">
            </b-form-input>
           </div>
         </div>
      </div>
      <div class="form-group row pt-2" v-if="checkTypeBoard(card)">
         <div class="col-md-12">
           <label for="txtGroup"><small class="text-danger" v-if="form.diasAtraso.required">*</small> Dias Atraso:</label>
           <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-clock"></i></span>
            <b-form-input type="number"
              placeholder="Dias de Atraso"
              v-model="form.diasAtraso.value"
              :maxlength="form.diasAtraso.maxlength"
              :required="form.diasAtraso.required"
              :state="form.diasAtraso.state">
            </b-form-input>
           </div>
         </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-12">
          <label><small class="text-danger">*</small> Valor:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-coins"></i></span>
              <money
                :placeholder="$lang.Currency.Placeholder"
                class="form-control text-bold"
                style="text-align: right;padding-left: 4px;"
                v-model.lazy="form.valor.value"
                :required="form.valor.required"
                :state="form.valor.state"
                v-bind="$lang.Currency.Format"
              ></money>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-12">
          <label> Observações:</label>
          <b-form-textarea
            v-model="form.observacao.value"
            :placeholder="'Digite a observação aqui'"
            :rows="form.observacao.rows"
            :size="form.observacao.maxlength"
            :noResize="form.observacao.noResize">
          </b-form-textarea>
          <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
        </div>
      </div>
     </div>
     <template #modal-footer>
       <div class="w-100 text-right">
         <button v-if="eventManager" @click.prevent="storeSubmit" type="button" class="btn btn-third btn-sm"  v-b-tooltip.hover :title="eventManager.hasNext ? 'Próximo' : 'Salvar'"><i :class="eventManager.hasNext ? 'far fa-arrow-alt-circle-right' : 'fas fa-check-circle'"></i><span class="d-md-down-none">&nbsp; {{ eventManager.hasNext ? 'Próximo' : 'Salvar' }}</span></button>
         <button v-else @click.prevent="onSave" type="button" class="btn btn-third btn-sm"  v-b-tooltip.hover :title="'Salvar'"><i :class="'fas fa-check-circle'"></i><span class="d-md-down-none">&nbsp; Salvar</span></button>
       </div>
     </template>
   </b-modal>
  </div>
</template>
<script>
import ProductModal from './productmodal.js'
export default ProductModal
</script>



// WEBPACK FOOTER //
// src/views/private/crm/details/product/modal/productmodal.vue